/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Refund_Permission_DeniedInputs */

const vi_error_refund_permission_denied = /** @type {(inputs: Error_Refund_Permission_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn chưa có quyền "Hoàn tiền cho khách". Hãy chọn "Không hoàn" hoặc nhờ người có quyền thực hiện.`)
};

/**

* @param {Error_Refund_Permission_DeniedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_refund_permission_denied = /** @type {((inputs?: Error_Refund_Permission_DeniedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Refund_Permission_DeniedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_refund_permission_denied(inputs)
});